import {
  ControlOutlined,
  EditOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  LeftCircleOutlined,
  PicLeftOutlined,
  ShopOutlined,
} from "@ant-design/icons";

import {
  Col,
  Row,
  Image,
  Skeleton,
  Rate,
  Avatar,
  Empty,
  Card,
  Tag,
} from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { authenticateToken } from "../../../utils/auth";
import { getImgUrl } from "../../../utils/index";
import { responseNotification } from "../../../utils/notify";
import EditProduct from "../EditProduct";

const ProductDetails = ({ selectedProductId }): ReactElement => {
  const [update, setUpdate] = useState(false);
  const [visible, setVisible] = useState(false);

  const [singleProductInfo, setSingleProductInfo] = useState({
    loading: false,
    data: null,
  });

  const [status, setStatus] = React.useState(undefined);

  const route = useParams();

  const fetchProductDetails = useCallback((getProductId) => {
    if (getProductId) {
      try {
        setSingleProductInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/product/details?slug=${getProductId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleProductInfo({
                loading: false,
                data: data?.data?.product,
              });
            } else {
              setSingleProductInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleProductInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleProductInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchProductDetails(selectedProductId || (route as any).slug);
  }, [fetchProductDetails, route, selectedProductId]);

  const UpdateStatus = useCallback(() => {
    if (status) {
      axios
        .put(
          `${process.env.REACT_APP_CATALOG_WRITER_API}/product`,
          {
            driverId: singleProductInfo?.data?.driverId,
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((data) => {
          if (data?.status === 200) {
            responseNotification("Status updated successfully!", "success");
            fetchProductDetails(selectedProductId);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [status]);

  useEffect(() => {
    UpdateStatus();
  }, [UpdateStatus]);

  const onEditModalClose = useCallback(() => {
    setUpdate(false);
    fetchProductDetails(selectedProductId);
  }, [fetchProductDetails, selectedProductId]);

  const product = singleProductInfo?.data;
  const currentRoute = useHistory();

  return (
    <div className="product-information-area">
      <Tab.Container id="left-tabs-example" defaultActiveKey="basic">
        <Row gutter={16} className="min-vh-100">
          <Col span={6}>
            <Card
              cover={
                <div className="product-details-wrapper-content">
                  <div className="show-details-inner-content">
                    <div className="product-image-content_">
                      <div className="product-banner_">
                        <div className="">
                          <Image
                            preview={{ visible: false }}
                            onClick={() => setVisible(true)}
                            src={getImgUrl(product?.productImage)}
                            alt={product?.name}
                            // width={200}
                            // className="rounded"
                          />
                          <div style={{ display: "none" }}>
                            <Image.PreviewGroup
                              preview={{
                                visible,
                                onVisibleChange: (vis) => setVisible(vis),
                              }}
                            >
                              <Image
                                preview={{ visible: false }}
                                onClick={() => setVisible(true)}
                                src={getImgUrl(product?.productImage)}
                                alt={product?.name}
                                className="rounded"
                              />
                              {product?.images?.length &&
                                product?.images?.map((image, index) => (
                                  <Image
                                    src={getImgUrl(image)}
                                    className="rounded"
                                  />
                                ))}
                              {product?.variations?.length &&
                                product?.variations?.map((variant, index) => (
                                  <Image
                                    src={variant?.imageUrl}
                                    className="rounded"
                                  />
                                ))}
                            </Image.PreviewGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="text-center px-2">{product?.name}</h6>

                  <div className="product-information-tab-menu">
                    <Nav variant="pills" className="flex-column">
                      <Nav.Item>
                        <Nav.Link eventKey="basic" className="d-flex-l">
                          <FileProtectOutlined style={{ fontSize: "18px" }} />
                          Basic Information
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="details" className="d-flex-l">
                          <PicLeftOutlined style={{ fontSize: "18px" }} />
                          Product Details
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="shop" className="d-flex-l">
                          <ShopOutlined style={{ fontSize: "18px" }} />
                          Shop Details
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="variations" className="d-flex-l">
                          <ControlOutlined style={{ fontSize: "18px" }} />
                           Variations
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                </div>
              }
            ></Card>
          </Col>
          <Col span={18}>
            <Card size="small">
              {singleProductInfo?.loading ? (
                <>
                  <Skeleton avatar active paragraph={{ rows: 20 }} />
                </>
              ) : (
                <div className="product-information-show-tab-wrapper">
                  <div className="inner-content">
                    <div className="single-content">
                      <Tab.Content>
                        <Tab.Pane eventKey="basic">
                          <div className="single-information-product-wrapper">
                            <div className="single-information-product-content">
                              <div className="info-icon">
                                <FileTextOutlined />
                              </div>
                              <div className="info-body">
                                <h3 className="title d-flex align-items-center justify-content-between">
                                  <span>
                                    <Link
                                      to={""}
                                      className="mr-2 text-dark"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        currentRoute?.goBack();
                                      }}
                                    >
                                      <LeftCircleOutlined />
                                    </Link>
                                    BASIC INFORMATION
                                  </span>
                                  <span className="">
                                    <Link
                                      to={`/products/${product?.slug}/edit`}
                                      className="btn btn-sm btn-danger"
                                    >
                                      <EditOutlined className="mr-1" /> Edit
                                    </Link>
                                  </span>
                                </h3>

                                <div className="inner-body">
                                  <div className="single">
                                    <span className="info-name">
                                      Product Name:{" "}
                                    </span>
                                    <span className="info-desc">
                                      {product?.name}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">Slug: </span>
                                    <span className="info-desc">
                                      {product?.slug}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">
                                      Product ID:{" "}
                                    </span>
                                    <span className="info-desc">
                                      {product?.id}
                                    </span>
                                  </div>

                                  {product?.barCode && (
                                    <div className="single">
                                      <span className="info-name">
                                        Barcode:{" "}
                                      </span>
                                      <span className="info-desc">
                                        {product?.barCode}
                                      </span>
                                    </div>
                                  )}

                                  {product?.sku && (
                                    <div className="single">
                                      <span className="info-name">SKU: </span>
                                      <span className="info-desc">
                                        {product?.sku}
                                      </span>
                                    </div>
                                  )}

                                  {product?.type && (
                                    <div className="single">
                                      <span className="info-name">Type: </span>
                                      <span className="info-desc">
                                        {product?.type?.split("_").join(" ")}
                                      </span>
                                    </div>
                                  )}

                                  <div className="single">
                                    <span className="info-name">
                                      Category Name:{" "}
                                    </span>
                                    <span className="info-desc">
                                      {product?.category?.title}
                                    </span>
                                  </div>

                                  {product?.category?.slug && (
                                    <div className="single">
                                      <span className="info-name">
                                        Category Slug:{" "}
                                      </span>
                                      <span className="info-desc">
                                        {product?.category?.slug}
                                      </span>
                                    </div>
                                  )}

                                  {product?.brand?.name && (
                                    <div className="single">
                                      <span className="info-name">
                                        Brand Name:{" "}
                                      </span>
                                      <span className="info-desc">
                                        {product?.brand?.name}
                                      </span>
                                    </div>
                                  )}

                                  {product?.campaign?.name && (
                                    <div className="single">
                                      <span className="info-name">
                                        Campaign:{" "}
                                      </span>
                                      <span className="info-desc">
                                        {product?.campaign?.name}
                                      </span>
                                    </div>
                                  )}

                                  <div className="single">
                                    <span className="info-name">
                                      Total Visitors:{" "}
                                    </span>
                                    <span className="info-desc">
                                      {product?.visitors}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">Rating</span>
                                    <span className="info-desc">
                                      {product?.numberOfRating ? (
                                        <Rate
                                          value={product?.rating || 0}
                                          disabled
                                        />
                                      ) : (
                                        <Rate value={0} disabled />
                                      )}
                                      <small className="ml-1">
                                        ({product?.numberOfRating})
                                      </small>
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">Status: </span>
                                    <span className="info-desc">
                                      <span
                                        className={`radius-btn ${
                                          product?.isActive === true
                                            ? "active-btn"
                                            : "inactive-btn"
                                        }`}
                                      >
                                        {product?.isActive === true
                                          ? "Active"
                                          : "Inactive"}
                                      </span>
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">
                                      Pre-Order:
                                    </span>
                                    <span className="info-desc">
                                      <span
                                        className={`radius-btn ${
                                          product?.bookingEnabled === true
                                            ? "active-btn"
                                            : "pending-btn"
                                        }`}
                                      >
                                        {product?.bookingEnabled === true
                                          ? "Allow Pre-Order"
                                          : "Not Allow"}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="details">
                          <div className="single-information-product-wrapper">
                            <div className="single-information-product-content">
                              <div className="info-icon">
                                <PicLeftOutlined />
                              </div>
                              <div className="info-body">
                                <h3 className="title d-flex align-items-center justify-content-between">
                                  <span>
                                    {" "}
                                    <Link
                                      to={""}
                                      className="mr-2 text-dark"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        currentRoute?.goBack();
                                      }}
                                    >
                                      <LeftCircleOutlined />
                                    </Link>
                                    PRODUCT DETAILS
                                  </span>

                                  <span className="">
                                    <Link
                                      to={`/products/${product?.slug}/edit`}
                                      className="btn btn-sm btn-danger"
                                    >
                                      <EditOutlined className="mr-1" /> Edit
                                    </Link>
                                  </span>
                                </h3>
                                <div className="inner-body">
                                  {product?.keyword && (
                                    <div className="single-inline mb-5">
                                      <h4 className="info-name border-bottom pb-2">
                                        Keyword :
                                      </h4>
                                      <span className="info-desc text-capitalize">
                                        {product?.keyword}
                                      </span>
                                    </div>
                                  )}

                                  {product?.description && (
                                    <div className="single-inline">
                                      <h4 className="info-name border-bottom pb-2">
                                        Description :
                                      </h4>

                                      <div
                                        className="description info-desc"
                                        dangerouslySetInnerHTML={{
                                          __html: product?.description,
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="shop">
                          <div className="single-information-product-wrapper">
                            <div className="single-information-product-content">
                              <div className="info-icon">
                                <ShopOutlined />
                              </div>
                              <div className="info-body">
                                <h3 className="title d-flex align-items-center justify-content-between">
                                  <span>
                                    {" "}
                                    <Link
                                      to={""}
                                      className="mr-2 text-dark"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        currentRoute?.goBack();
                                      }}
                                    >
                                      <LeftCircleOutlined />
                                    </Link>
                                    SHOP DETAILS
                                  </span>

                                  <span className="">
                                    <Link
                                      to={`/products/${product?.slug}/edit`}
                                      className="btn btn-sm btn-danger"
                                    >
                                      <EditOutlined className="mr-1" /> Edit
                                    </Link>
                                  </span>
                                </h3>
                                <div className="inner-body">
                                  <div className="shop-image-content mb-5">
                                    <div className="shop-banner">
                                      <Image
                                        src={product?.shop?.banner}
                                        className="rounded"
                                        alt={product?.shop?.name}
                                        style={{ maxHeight: 300 }}
                                      />
                                    </div>

                                    <div className="shop-image-content">
                                      <div className="shop-logo">
                                        <Avatar
                                          size={105}
                                          src={product?.shop?.logo}
                                          className=""
                                        />
                                      </div>
                                      <div className="body">
                                        <h4>{product?.shop?.name}</h4>
                                        <b className="py-2 px-5 border text-danger rounded">
                                          Hotline:{" "}
                                          {product?.shop?.contactNumber}
                                        </b>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="single">
                                      <span>Shop Name</span>
                                      <span>{product?.shop?.name}</span>
                                    </div> */}

                                  <div className="single">
                                    <span className="info-name">Shop ID</span>
                                    <span className="info-desc">
                                      {product?.shop?.id}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">Shop Slug</span>
                                    <span className="info-desc">
                                      {product?.shop?.slug}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">
                                      Free Delivery
                                    </span>
                                    <span className="info-desc">
                                      {product?.shop?.isFreeDelivery === true
                                        ? "Free Delivery"
                                        : "Paid Delivery"}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">
                                      Base Delivery Charge
                                    </span>
                                    <span className="info-desc">
                                      {product?.shop?.baseDeliveryCharge}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">
                                      Prepare Time
                                    </span>
                                    <span className="info-desc">
                                      {product?.shop?.prepareTime}
                                    </span>
                                  </div>

                                  {product?.shop?.country && (
                                    <div className="single">
                                      <span className="info-name">Country</span>
                                      <span className="info-desc">
                                        {product?.shop?.country}
                                      </span>
                                    </div>
                                  )}

                                  {product?.shop?.city && (
                                    <div className="single">
                                      <span className="info-name">City</span>
                                      <span className="info-desc">
                                        {product?.shop?.city}
                                      </span>
                                    </div>
                                  )}

                                  {product?.shop?.area && (
                                    <div className="single">
                                      <span className="info-name">Area</span>
                                      <span className="info-desc">
                                        {product?.shop?.area}
                                      </span>
                                    </div>
                                  )}

                                  {product?.shop?.address && (
                                    <div className="single">
                                      <span className="info-name">Address</span>
                                      <span className="info-desc">
                                        {product?.shop?.address}
                                      </span>
                                    </div>
                                  )}

                                  {product?.shop?.ownerId && (
                                    <div className="single">
                                      <span className="info-name">
                                        Owner Id
                                      </span>
                                      <span className="info-desc">
                                        {product?.shop?.ownerId}
                                      </span>
                                    </div>
                                  )}

                                  {product?.shop?.mobileNumber && (
                                    <div className="single">
                                      <span className="info-name">
                                        Mobile Number
                                      </span>
                                      <span className="info-desc">
                                        {product?.shop?.mobileNumber}
                                      </span>
                                    </div>
                                  )}

                                  {product?.shop?.email && (
                                    <div className="single">
                                      <span className="info-name">
                                        Email Address
                                      </span>
                                      <span className="info-desc">
                                        {product?.shop?.email}
                                      </span>
                                    </div>
                                  )}

                                  <div className="single">
                                    <span className="info-name">Shop Type</span>
                                    <span className="info-desc">
                                      {product?.shop?.type
                                        ?.split("_")
                                        .join(" ")}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">Status</span>
                                    <span className="info-desc">
                                      <span
                                        className={`radius-btn ${product?.shop?.status?.toLowerCase()}-btn`}
                                      >
                                        {product?.shop?.status
                                          ?.split("_")
                                          .join(" ")}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="variations">
                          <div className="single-information-product-wrapper">
                            <div className="single-information-product-content">
                              <div className="info-icon">
                                <ControlOutlined />
                              </div>
                              <div className="info-body">
                                <h3 className="title d-flex align-items-center justify-content-between">
                                  <span>
                                    {" "}
                                    <Link
                                      to={""}
                                      className="mr-2 text-dark"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        currentRoute?.goBack();
                                      }}
                                    >
                                      <LeftCircleOutlined />
                                    </Link>
                                    VARIATIONS
                                  </span>

                                  <span className="">
                                    <Link
                                      to={`/products/${product?.slug}/edit`}
                                      className="btn btn-sm btn-danger"
                                    >
                                      <EditOutlined className="mr-1" /> Edit
                                    </Link>
                                  </span>
                                </h3>
                                <div className="inner-body row">
                                  {product?.variations?.length ? (
                                    product?.variations?.map(
                                      (variant, index) => (
                                        <div key={index} className="col-md-6">
                                          <Card
                                            className="mb-3"
                                            // title={variant?.variationName}
                                            cover={
                                              <>
                                                {/* {variant?.imageUrl ? ( */}
                                                <div className="p-1">
                                                  <Avatar
                                                    shape="square"
                                                    size={150}
                                                    src={variant?.imageUrl}
                                                  />
                                                </div>
                                                {/* // ) } */}
                                              </>
                                            }
                                          >
                                            {/* <div className="card-header">
                                          <h6 className="mb-0">
                                            <span className="info-name">
                                              Variation Name: {""}
                                            </span>
                                            <span className="info-desc">
                                              {variant?.variationName}
                                            </span>
                                          </h6>
                                        </div> */}
                                            <div>
                                              <div className="single">
                                                <span className="info-name">
                                                  Variation Name
                                                </span>
                                                <span className="info-desc">
                                                  {variant?.variationName}
                                                </span>
                                              </div>

                                              {variant?.barCode && (
                                                <div className="single">
                                                  <span className="info-name">
                                                    Barcode
                                                  </span>
                                                  <span className="info-desc">
                                                    {variant?.barCode}
                                                  </span>
                                                </div>
                                              )}

                                              <div className="single">
                                                <span className="info-name">
                                                  Variation Id
                                                </span>
                                                <span className="info-desc">
                                                  {variant?.variationId}
                                                </span>
                                              </div>

                                              <div className="single">
                                                <span className="info-name">
                                                  MRP
                                                </span>
                                                <span className="info-desc">
                                                  {variant?.price?.mrp}{" "}
                                                  {variant?.price?.currencyCode}
                                                </span>
                                              </div>
                                              <div className="single">
                                                <span className="info-name">
                                                  TP
                                                </span>
                                                <span className="info-desc">
                                                  {variant?.price?.tp}{" "}
                                                  {variant?.price?.currencyCode}
                                                </span>
                                              </div>

                                              {variant?.price
                                                ?.discountedPrice && (
                                                <div className="single">
                                                  <span className="info-name">
                                                    Discounted Price
                                                  </span>
                                                  <span className="info-desc">
                                                    {
                                                      variant?.price
                                                        ?.discountedPrice
                                                    }{" "}
                                                    {
                                                      variant?.price
                                                        ?.currencyCode
                                                    }
                                                  </span>
                                                </div>
                                              )}

                                              {variant?.maximumOrderLimit && (
                                                <div className="single">
                                                  <span className="info-name">
                                                    Maximum Order Limit
                                                  </span>
                                                  <span className="info-desc">
                                                    {variant?.maximumOrderLimit}
                                                  </span>
                                                </div>
                                              )}

                                              <div className="single">
                                                <span className="info-name">
                                                  Stock
                                                </span>
                                                <span className="info-desc">
                                                  <Tag
                                                    className={`font-weight-bold px-3 ${
                                                      variant?.stock < 10
                                                        ? `text-danger`
                                                        : `text-success`
                                                    }`}
                                                  >
                                                    {variant?.stock}
                                                  </Tag>
                                                </span>
                                              </div>

                                              <h6 className="mt-4 border-bottom pb-2">
                                                <b>Product Discount :</b>
                                              </h6>
                                              <div className="single">
                                                <span className="info-name">
                                                  Discount in Amount
                                                </span>
                                                <span className="info-desc">
                                                  {variant?.productDiscount
                                                    ?.flat || 0}{" "}
                                                  {variant?.price?.currencyCode}
                                                </span>
                                              </div>
                                              <div className="single">
                                                <span className="info-name">
                                                  Discount in Percentage
                                                </span>
                                                <span className="info-desc">
                                                  {variant?.productDiscount
                                                    ?.percentage || 0}{" "}
                                                  {"%"}
                                                </span>
                                              </div>
                                              {
                                                // data.item?.products?.length ?
                                                variant
                                                  ?.quantitativeProductDiscount
                                                  ?.freeProduct ? (
                                                  <div className="">
                                                    <h6 className="mt-5 border-bottom pb-2">
                                                      <b>
                                                        Quantitative Product
                                                        Discount:
                                                      </b>
                                                    </h6>
                                                    <div className="single">
                                                      <span className="info-name">
                                                        Free Product
                                                      </span>
                                                      <span className="info-desc">
                                                        {
                                                          variant
                                                            ?.quantitativeProductDiscount
                                                            ?.freeProduct
                                                        }
                                                      </span>
                                                    </div>
                                                    <div className="single">
                                                      <span className="info-name">
                                                        Minimum Quantity
                                                      </span>
                                                      <span className="info-desc">
                                                        {
                                                          variant
                                                            ?.quantitativeProductDiscount
                                                            ?.minimumQuantity
                                                        }
                                                      </span>
                                                    </div>
                                                    <div className="single">
                                                      <span className="info-name">
                                                        Product Discount in
                                                        Amount
                                                      </span>
                                                      <span className="info-desc">
                                                        {
                                                          variant
                                                            ?.quantitativeProductDiscount
                                                            ?.productDiscount
                                                            ?.flat
                                                        }
                                                      </span>
                                                    </div>
                                                    <div className="single">
                                                      <span className="info-name">
                                                        Product Discount in
                                                        Percent
                                                      </span>
                                                      <span className="info-desc">
                                                        {
                                                          variant
                                                            ?.quantitativeProductDiscount
                                                            ?.productDiscount
                                                            ?.percentage
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  ""
                                                )
                                              }
                                            </div>
                                          </Card>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <Empty />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </Tab.Container>

      <Modal
        size="lg"
        className="update-campaign-modal edit-product-modal-area"
        // show={!!singleProduct}
        show={!!setSingleProductInfo && update}
        onHide={onEditModalClose}
        backdrop="static"
        keyboard={false}
        animation
        width={1200}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Update Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditProduct
            singleProductData={singleProductInfo?.data}
            fetchProductDetails={() => fetchProductDetails(selectedProductId)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

ProductDetails.propTypes = {
  selectedProductId: PropTypes.string,
};

export default ProductDetails;
